import { NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { conditionalForms } from '../config/conditional-forms';

export const getConditionalFunction = (formId: string): NextFunction => {
    const getNextPageFuncReference = conditionalForms[formId];

    if (!getNextPageFuncReference) {
        throw new Error('Unknown formId - No custom function defined: ' + formId);
    }

    return getNextPageFuncReference;
};

export const hasConditionalPages = (formId: string): boolean => {
    return formId in conditionalForms;
};
